export const email = 'lionel.kossi@gmail.com';
export const githubLink = 'https://github.com/kosher9';
export const phone = '+22890488895';
export const resume = 'https://docs.google.com/document/d/1XJRpZdhGW1Qjjo_HFlCn1CDDiP_owGtDT461nAhuUn4/edit?usp=sharing';

export const platform = {
  id: 0,
  name: 'Platforms',
  value: ['Web', 'Android'],
};

export const frontEnd = {
  id: 1,
  name: 'Front-End',
  value: ['JavaScript', 'React', 'Redux', 'jQuery', 'HTML5', 'CSS3'],
};

export const backEnd = {
  id: 2,
  name: 'Back-End',
  value: ['Ruby', 'Rails', 'Golang', 'Kotlin', 'NodeJs', 'MySQL', 'PostgreSQL', 'MongoDB', 'Google Cloud Platform'],
};

export const toolsMethods = {
  id: 3,
  name: 'Tools & Methods',
  value: ['Git', 'GitHub', 'Heroku', 'Netlify', 'Mobile/Responsive Development', 'RSpec', 'TDD', 'Chrome Dev Tools'],
};

export const professional = {
  id: 4,
  name: 'Professional',
  value: ['Remote Pair-Programming', 'Teamwork', 'Mentoring'],
};

export const color = {
  primary: '#11081F',
  secondary: '#A773C4',
  tertiary: '#0c4c88;',
  quaternary: '#300B33',
};

export const KEY_CODES = {
  ESCAPE: 27,
  ESCAPE_IE11: 27,
  TAB: 9,
};
